import { render, staticRenderFns } from "./facets-configuration.component.vue?vue&type=template&id=4c9c106e&scoped=true"
import script from "./facets-configuration.component.vue?vue&type=script&lang=ts"
export * from "./facets-configuration.component.vue?vue&type=script&lang=ts"
import style0 from "./facets-configuration.component.vue?vue&type=style&index=0&id=4c9c106e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9c106e",
  null
  
)

export default component.exports